import { defineComponent as _defineComponent } from 'vue'
interface TravStars {
        stars: number
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TravStars',
  props: {
    stars: null
  },
  setup(__props: any) {

    

return { __sfc: true, }
}

})